module.exports = __webpack_public_path__ + "static/media/event_slide_5.45dc048f.png";